import { route } from "@circle-react/lib/routes/define";

export const accessGroupRoutes = {
  list: route("/settings/access_groups", {
    title: "Access groups",
    requires: "admin",
    description: "Lists all access groups in the community's settings area.",
  }),

  detail: route("/settings/access_groups/:id", {
    title: "Access group detail",
    requires: "admin",
    description: "Detail page for a specific access group.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the access group.",
      },
    },
  }),

  edit: route("/settings/access_groups/:id/edit", {
    title: "Edit access group",
    requires: "admin",
    description: "Edit form for a specific access group.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the access group to edit.",
      },
    },
  }),
};
